import { render, staticRenderFns } from "./examsence.vue?vue&type=template&id=f6b7a596"
import script from "./examsence.vue?vue&type=script&lang=js"
export * from "./examsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/examsence.vue
// module id = null
// module chunks = 